var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "203.823 262.19 30 30",
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDD0D-System-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1, 0, 0, 1.111111, 205.66626, 262.555573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_fluent_data_line_24_filled",
    fill: "#212121",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,6 C16,4.34315 17.3431,3 19,3 C20.6569,3 22,4.34315 22,6 C22,7.65685 20.6569,9 19,9 C18.838,9 18.679,8.98716 18.524,8.96245 L16.4862,12.3205 C16.8105,12.7997 17,13.3777 17,14 C17,15.6569 15.6569,17 14,17 C13.0972,17 12.2875,16.6012 11.7375,15.9701 L7.99584,17.8407 C7.9986,17.8934 8,17.9466 8,18 C8,19.6569 6.65685,21 5,21 C3.34315,21 2,19.6569 2,18 C2,16.3431 3.34315,15 5,15 C6.0662,15 7.00249,15.5562 7.53455,16.3943 L11.066,14.6288 C11.0228,14.4261 11,14.2157 11,14 C11,12.3431 12.3431,11 14,11 C14.4821,11 14.9376,11.1137 15.3413,11.3158 L17.1391,8.35326 C16.4452,7.80378 16,6.95388 16,6 Z",
    id: "\\uD83C\\uDFA8-Color",
    style: {
      fill: "rgb(0, 123, 255)"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.52db3eb82df6ca5cc08f8eac98327491.svg";
export { ForwardRef as ReactComponent };